import { createFileRoute, redirect } from "@tanstack/react-router";
import { ControlCodes, queries } from "@theprelude/core";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { Advisories } from "@/components/threat-intel/advisories";
import { AdvisoriesLoading } from "@/components/threat-intel/advisories-loading";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/threat-intel/import/feed")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Threat Intel");
    const authConfig = await context.auth.getAuthConfig();
    const account = await context.queryClient.ensureQueryData(
      queries.iam.getAccount(authConfig),
    );

    await authorizeFeatures(context, ["detect", "threat_intel"]);

    const hasCrowdstrike = account.controls.some(
      (c) => c.id === ControlCodes.CROWDSTRIKE,
    );

    if (!hasCrowdstrike) {
      throw redirect({ to: "/threat-intel/import/feed-notice" });
    }
  },
  component: Advisories,
  pendingComponent: AdvisoriesLoading,
});
